import React from "react";
import { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum.ts";
import BeerrallyLogo from "../BeerrallyLogo/BeerrallyLogo";
import ChlastLogo from "../ChlastLogo/ChlastLogo";
import KdesuLogo from "../KdesuLogo/KdesuLogo";
import SkladkaLogo from "../SkladkaLogo/SkladkaLogo";

export interface PicoAppLogoProps {
  size?: number;
}

export const picoAppLogoMap: Partial<Record<PicoAppEnum, React.FC<PicoAppLogoProps>>> = {
  [PicoAppEnum.BEERRALLY_PICO]: BeerrallyLogo,
  [PicoAppEnum.CHLAST_PICO]: ChlastLogo,
  [PicoAppEnum.KDESU_PICO]: KdesuLogo,
  [PicoAppEnum.SKLADKA_PICO]: SkladkaLogo,
};
